// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.control-charts-container[data-v-57ae31dc] {\n  margin-top: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
